module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "letaxi_white.aca66d0e.png" + "?" + Date.now();